<template>
  <div class="newrealauth">
     <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="证件上传"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <!-- 提交状态 -->
    <template v-if="!result">
      <div class="commit-info">
        <div class="guide-title">请上传{{ name }}本人的{{ titlemap[authType] }}</div>
        <div class="guide-info">根据法律法规和监管要求，为保障平台交易安全，需要收集您的身份信息用于实人认证，转转将保护您的个人信息安全。</div>
        <section v-if="['0','1'].includes(authType)" class="upload-area">
          <media-upload-item ocr :sdkOptions="{ type: '1' }" :authType="authType" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
          </media-upload-item>
          <media-upload-item ocr :sdkOptions="{ type: '1' }" :authType="authType" :cover="backCover" :tip="backTip" type="back" @uploaded="backPicUploaded">
          </media-upload-item>
        </section>
        <section v-else class="upload-area-single">
          <media-upload-item ocr :authType="authType" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
          </media-upload-item>
        </section>

        <z-checkbox-group v-model="radio">
          <z-checkbox name="1">
            我已阅读并同意
            <span v-if="isZZ" :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
            <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
            <span v-if="isZLJ" :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
          </z-checkbox>
        </z-checkbox-group>
        <z-button-group>
          <z-button type="primary" :loading="submiting" :disabled="!canSubmit" @click="submit">提交</z-button>
        </z-button-group>
      </div>
    </template>

    <!-- 结果状态 - 确保本人操作页面 -->
    <template v-if="result">
      <div class="recordface">
        <div class="title">请确保本人操作</div>
        <!-- generated by ai -->
        <img :src="$setPicSize(headimg)" alt="">
        <div class="guide-info">根据法律法规和监管要求，为保障平台交易安全，需要收集您的人脸信息用于实人认证，转转将保护您的个人信息安全。</div>
        <div class="buttonlist">
          <z-button @click="back">取消</z-button>
          <z-button type="primary" @click="startVerify" :style="isHeroClub ? heroClubButtonStyle : {}">开始扫脸</z-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { NavBar, Button, ButtonGroup, FixTop, Checkbox, CheckboxGroup } from '@zz-common/zz-ui';
import { presubmitBeforeFaceCer } from '@api/resourceApi'
import MediaUploadItem from '../Card/MediaUploadItem/MediaUploadItem'
import { lego } from '@zz-common/lego'
// generated by ai
import { setPicSize } from '@zz-common/zz-utils'
import { queryParams, getCookie, curApp, compatibleHarmony, isHeroClubByUa } from '../../../lib/utils'

const query = queryParams()

export default {
  name: 'HKMTFace',
  data() {
    return {
      radio: [],
      picKeyFro: '',
      picKeyBack: '',
      //顶部文字
      title: '',
      headimg: require('./images/head.png'),
      name: decodeURI(query.name) || decodeURI(this.$route.query.name) || '',
      cardId: query.cardId || this.$route.query.cardId || '',
      sourcecode: query.sourcecode || this.$route.query.sourcecode || 'hkmt_face_page',
      authType: query.authType || this.$route.query.authType, //认证方式
      strategyid: query.strategyid || this.$route.query.strategyid, //策略ID
      result: query.result === 'true' || this.$route.query.result === 'true' || false,
      submiting: false,
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      isHeroClub: isHeroClubByUa(),
      heroClubButtonStyle: {
        background: '#111111',
        color: '#F2D3A9',
        border: '1px solid #111111'
      },
      actions: [
        { name: '中华人民共和国居民身份证', value: '0' },
        { name: '中华人民共和国港澳台居民居住证', value: '1' },
        { name: '港澳居民来往内地通行证', value: '2' },
        { name: '台湾居民来往大陆通行证', value: '3' }
      ],
      titlemap: {
        0: '身份证',
        1: '居住证',
        2: '通行证',
        3: '通行证'
      },
      frontCover1: require('@assets/img/id_card_front_sample_new.png'),
      frontCover2: require('@assets/img/id_card_entrance_new.png'),
      backCover1: require('@assets/img/id_card_back_sample_new.png'),
      backTip: '',
      frontTip: ''
    }
  },
  computed: {
    canSubmit() {
      if (['0', '1'].includes(this.authType)) {
        return this.radio.length > 0 && this.picKeyFro && this.picKeyBack
      } else {
        return this.radio.length > 0 && this.picKeyFro
      }
    },
    cardType() {
      return this.actions.find(t => t.value == this.authType)?.name || '-'
    },
    frontCover() {
      if (['0', '1'].includes(this.authType)) {
        return this.frontCover1
      } else {
        return this.frontCover2
      }
    },
    backCover() {
      return this.backCover1
    }
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-checkbox-group': CheckboxGroup,
    'z-checkbox': Checkbox,
    'z-button-group': ButtonGroup,
    MediaUploadItem
  },
  mounted() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    lego.send({
      pagetype: 'hkmt_face_supply',
      actiontype: 'show',
      backup: {
        sourcecode: this.sourcecode,
        version: getCookie('v'),
        app: native.in('zz') ? 'zz' : 'zlj',
        authType: this.authType
      }
    })
  },
  methods: {
    // generated by ai
    $setPicSize(url) {
      return setPicSize(url)
    },
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1',
        needClose: '0'
      })
    },
    frontPicUploaded(rst, ocr = '') {
      this.picKeyFro = rst
      if (ocr && !this.name && !this.cardId) {
        this.name = ocr.name
        this.cardId = ocr.cardId
      }
    },
    backPicUploaded(rst, _ocr = '') {
      this.picKeyBack = rst
    },
    submit() {
      lego.send({
        pagetype: 'hkmt_face_supply',
        actiontype: 'submit',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          authType: this.authType
        }
      })
      this.submiting = true
      const params = {
        uid: native.getUid(),
        sourceCode: this.sourcecode,
        type: this.authType,
        picKeyFro: this.picKeyFro,
        picKeyBack: this.picKeyBack,
        name: this.name,
        cardId: this.cardId
      }
      presubmitBeforeFaceCer(params)
        .then((res) => {
          if (res.code !== 0) {
            lego.send({
              pagetype: 'hkmt_face_supply',
              actiontype: 'fail',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj',
                authType: this.authType
              }
            })
            this.$toast(res.message || '提交证件信息与填写信息信息不一致，请确认信息是否正确')
          } else {
            lego.send({
              pagetype: 'hkmt_face_supply',
              actiontype: 'success',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj',
                authType: this.authType
              }
            })
            this.result = true
          }
          this.submiting = false
        })
        .catch((res) => {
          console.log(res)
          this.submiting = false
        })
    },
    back() {
      this.result = false
    },
    startVerify() {
      lego.send({
        pagetype: 'hkmt_face_supply',
        actiontype: 'start_verify',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: curApp()
        }
      })
      if (compatibleHarmony()) return;
      if (native.in('zz') || native.in('zzqcidentity') || this.isHeroClub) {
        native.wrap('startFaceVerify')(
          {
            name: this.name,
            cardId: this.cardId,
            sourceCode: this.sourcecode,
            isShowPrivacyPage: '0',
            strategyId: this.strategyid
          },
          (res) => {
            if (res.code == '0') {
              lego.send({
                pagetype: 'hkmt_face_supply',
                actiontype: 'verify_success',
                backup: {
                  sourcecode: this.sourcecode,
                  version: getCookie('v'),
                  app: native.in('zz') ? 'zz' : 'zzqcidentity'
                }
              })
              if (res.jumpUrl) {
                native.skipToUrl({
                  targetUrl: res.jumpUrl,
                  needClose: '1'
                })
              } else {
                this.$router.replace({
                  path: '/realauth/verifyface/result',
                  query: {
                    sourcecode: this.sourcecode,
                    agreementNo: res.agreementNo,
                    strategyid: this.strategyid
                  }
                })
              }
            }
            if (res.code == '-1') {
              this.result = false
              lego.send({
                pagetype: 'hkmt_face_supply',
                actiontype: 'verify_fail',
                backup: {
                  sourcecode: this.sourcecode,
                  version: getCookie('v'),
                  app: native.in('zz') ? 'zz' : 'zzqcidentity'
                }
              })
            }
          }
        )
      }
      if (native.in('zlj')) {
        native.wrap('faceRecognitionOcr')({
          source_code: this.sourcecode,
          card_name: this.name,
          card_no: this.cardId
        },
        (res) => {
          const { statusCode, statusText, data: { agreementNo } = {} } = res;
          if (statusCode && agreementNo) {
            // 处理成功情况
            this.$toast('认证成功')
          } else if (statusCode && statusText) {
            this.$toast(statusText)
          }
        }
        )
      }
    },
    closePage() {
      native.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
